module.exports = __webpack_public_path__ + "static/media/Handyman.9606d804.png";